import React from 'react';
import {View, Text} from '@applane/react-core-components';
import {WithInputWrapper, WithInputError} from '@applane/react-input-wrapper';
import RadioButton from './RadioButton';
import {getRenderComponent} from './Utility';
import WithFetch from './WithFetch';

class RadioGroup extends React.Component {
  render() {
    let {
      value,
      options,
      style,
      optionStyle,
      labelStyle,
      selectedLabelStyle,
      direction = 'row',
      labelDirection = 'right',
      onChangeValue,
      defaultValue,
      renderLabel,
      valueField,
      ...restProps
    } = this.props;
    if (!options || !options.length) {
      return null;
    }
    if (value === undefined || value === null) {
      value = defaultValue;
    }
    return (
      <View
        style={{
          ...(direction === 'row'
            ? {flex: 1, flexWrap: 'wrap', flexDirection: 'row'}
            : {}),
          ...style,
        }}>
        {options.map(option => {
          if (!option) {
            return null;
          }
          let optionValue = option;
          let optionLabel = option;
          if (typeof option !== 'string') {
            optionValue = option.value;
            optionLabel = option.label;
          }
          let selected = false;
          if (value !== undefined && optionValue !== undefined) {
            if (
              typeof value === 'object' &&
              typeof optionValue === 'object' &&
              valueField
            ) {
              selected = value[valueField] === optionValue[valueField];
            } else {
              selected = value === optionValue;
            }
          }

          let labelComponent = renderLabel ? (
            getRenderComponent(renderLabel, option)
          ) : optionLabel ? (
            <Text
              style={{
                ...labelStyle,
                ...(selected ? selectedLabelStyle : {}),
              }}>
              {optionLabel}
            </Text>
          ) : (
            void 0
          );
          return (
            <View
              style={{
                flexDirection: 'row',
                alignItems: 'center',
                ...optionStyle,
              }}>
              {labelDirection === 'left' ? labelComponent : void 0}
              <RadioButton
                {...restProps}
                selected={selected}
                onChangeValue={(_value, e) => {
                  if (value !== optionValue) {
                    onChangeValue && onChangeValue(optionValue, e);
                  }
                }}
              />
              {labelDirection === 'right' ? labelComponent : void 0}
            </View>
          );
        })}
      </View>
    );
  }
}

RadioGroup.defaultProps = {
  optionStyle: {paddingRight: 8},
  labelStyle: {paddingLeft: 8},
};

RadioGroup = WithFetch(WithInputWrapper(WithInputError(RadioGroup)));

export default RadioGroup;
